import { Column } from "react-table";
const ColumnSettings: Array<Column> = [
  {
    Header: "Etichetta",
    accessor: "label",
    width: 100,
  },
  {
    Header: "Valore",
    accessor: "value",
    width: 300,
  },
  {
    Header: "Descrizione",
    accessor: "description"
  }
]; 
export default ColumnSettings;